import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius4, colorBgBase, colorBgPrimaryLight, space12, space2, space6 } = theme();

  return StyleSheet.create({
    ordersWrapper: {
      backgroundColor: colorBgBase,
      padding: space6,
      paddingTop: space2,
    },
    ordersWrapperLarge: {
      borderRadius: borderRadius4,
      marginVertical: space12,
    },
    row: {
      backgroundColor: colorBgPrimaryLight,
      flex: 1,
      justifyContent: "center",
      maxWidth: "100%",
    },
    smallRow: {
      paddingHorizontal: 0,
    },
    spinnerWrapper: {
      alignItems: "center",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "center",
      width: "100%",
    },
  });
};

export { style };
